
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.969.259l.524 1.184 1.288.133-.964.865.272 1.266-1.12-.65-1.12.65.272-1.266-.965-.865 1.289-.133L8.969.26zM8.969 14.567l.524 1.184 1.288.133-.964.865.272 1.266-1.12-.65-1.12.65.272-1.266-.965-.865 1.289-.133.524-1.184zM13.971 1.819l.524 1.184 1.289.133-.965.864.272 1.267-1.12-.65-1.12.65L13.123 4l-.964-.864 1.288-.133.524-1.184zM4.298 1.819l.524 1.184 1.288.133L5.146 4l.272 1.267-1.12-.65-1.12.65L3.448 4l-.964-.864 1.288-.133.525-1.184zM13.971 12.037l.524 1.184 1.289.133-.965.864.272 1.267-1.12-.65-1.12.65.272-1.267-.964-.864 1.288-.133.524-1.184zM3.966 12.037l.525 1.184 1.288.133-.964.864.272 1.267-1.12-.65-1.12.65.271-1.267-.964-.864 1.288-.133.524-1.184zM15.76 7.133l.525 1.184 1.288.133-.964.865.272 1.266-1.12-.65-1.12.65.271-1.266-.964-.865 1.288-.133.525-1.184zM2.392 7.133l.524 1.184 1.288.133-.964.865.272 1.266-1.12-.65-1.12.65.271-1.266L.58 8.45l1.288-.133.525-1.184z","fill":"#FFC700"}})])
          )
        }
      }
    